var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFowardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.195262 6.63775C-0.0650874 6.3774 -0.0650874 5.95529 0.195262 5.69494L2.39052 3.49967L0.195262 1.30441C-0.0650874 1.04406 -0.0650874 0.621952 0.195262 0.361603C0.455612 0.101253 0.877722 0.101253 1.13807 0.361603L3.80474 3.02827C4.06509 3.28862 4.06509 3.71073 3.80474 3.97108L1.13807 6.63775C0.877722 6.8981 0.455612 6.8981 0.195262 6.63775Z",
    fill: "#6E7682"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFowardArrow);
export default __webpack_public_path__ + "static/media/foward-arrow.ac03da0dbf59ce33e81560c61f8473ab.svg";
export { ForwardRef as ReactComponent };